import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Actions, ofActionDispatched, ofActionSuccessful, ofActionErrored } from '@ngxs/store';
import { filter, map, mergeMap } from 'rxjs/operators';
import { DialogService } from './modules/core/services/dialog.service';
import { UpdatePurchase, NewPurchase, CancelPurchase, FinalizePurchase } from './modules/purchase/actions/purchase.action';
import { Login } from './modules/core/actions/auth.action';
import { of } from 'rxjs';
import { RemoteLoggingService } from './modules/core/services/remote-logging.service';
import {GoogleAnalyticsService} from "@app/modules/google-analytics/google-analytics.service";
import {AppConfigService} from "@app/modules/app-load/services/app-config.service";

const DEFAULT_APPLICATION_TITLE = 'iQ';

@Component({
  selector: 'iq-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = DEFAULT_APPLICATION_TITLE;

  constructor(
    translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private actions$: Actions,
    private dialogService: DialogService,
    private remoteLoggingService: RemoteLoggingService,
    private appConfigService: AppConfigService,
    private gaService: GoogleAnalyticsService
    ) {
    translate.setDefaultLang('en');
    translate.use('en');

    // this.actions$.pipe( ofActionErrored( Login ) ).subscribe(
    //   e =>  { console.log( 'ofActionErrored ' , e ); return of([]); }
    // );

    this.actions$.pipe(ofActionDispatched(UpdatePurchase, NewPurchase, CancelPurchase, FinalizePurchase)).subscribe(() => {
      this.dialogService.showLoadingDialog();
    });

    this.actions$.pipe(ofActionSuccessful(UpdatePurchase, NewPurchase, CancelPurchase, FinalizePurchase)).subscribe(() => {
      this.dialogService.closeLoadingDialog();
    });

    if (appConfigService.getConfig().gtmAccountId) {
      console.log("-----TRACKING ID: " + appConfigService.getConfig().gtmAccountId + "---");
      gaService.loadGoogleAnalytics(router, appConfigService.getConfig().gtmAccountId)
    }

  }
  ngOnDestroy() {

  }

  ngOnInit() {
     this.initBrowserWindowTitleUpdates();
     this.remoteLoggingService.initialize();
  }

  private initBrowserWindowTitleUpdates() {
    this.router.events.pipe(
      filter(
        (event) => event instanceof NavigationEnd ),
      map(() => {
        let route = this.activatedRoute;

        while ( route.firstChild ) { route = route.firstChild; }
        return route;
      })
      ,
      mergeMap((r) => {
        return r.data;
       }
      ),
      map( (data) => {
        return ( data.title ) ? data.title : DEFAULT_APPLICATION_TITLE;
      }
      )).subscribe(
        title => this.titleService.setTitle( title )
      );
  }
}
